export default function Template(templateConfig, itemTemplate, highlightTemplate, dotHighlightTemplate, cursorTemplate) {
  this.templateConfig = templateConfig;
  this.itemTemplate = itemTemplate;
  this.highlightTemplate = highlightTemplate;
  this.dotHighlightTemplate = dotHighlightTemplate;
  this.cursorTemplate = cursorTemplate;
};
